module.exports = __webpack_public_path__ + "static/b50ede0926de2491f3bbb4743239f4e75a80e81639f4dd05c786df4354b377d1-828f3991d1b5bf69feb750e6aae22d88.png";